module.exports = __webpack_public_path__ + "static/media/entry-search.5983d37f.svg";